<template>
  <b-overlay :show="loading">
    <div class="service-wages-container p-4">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-light-blue py-3 d-flex justify-content-between align-items-center border-bottom">
          <div class="text-center flex-grow-1">
            <p class="mb-1 font-weight-bold" style="color: #333; font-size: 0.85rem">Bangladesh Gazette - বাংলাদেশ গেজেট</p>
            <h5 class="mb-1 font-weight-bold text-primary">Form No: 07</h5>
            <p class="mb-1 text-muted small">Under Section 7, Rules (1) and (2) (Part C)</p>
            <h6 class="mb-0 font-weight-bold">Service, Wages and Allowance Record</h6>
            <p class="mb-0 small bn-text"> সার্ভিস রেকর্ড ও মজুরি এবং ভাতা সংক্রান্ত তথ্য</p>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-bordered mb-0 custom-table">
              <thead class="text-center bg-light-cyan">
                <tr>
                  <th rowspan="2" style="vertical-align: middle">
                    Date Starting<br>
                    <small class="bn-text">আরম্ভের তারিখ</small><br>
                    <small>(১)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Job Title & Card<br>
                    <small class="bn-text">পদ ও কার্ড নম্বর</small><br>
                    <small>(২)</small>
                  </th>
                  <th colspan="5">
                    Monthly Wage Rate<br>
                    <small class="bn-text">মাসিক মজুরির হার</small><br>
                    <small>(৩)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Other Allowances<br>
                    <small class="bn-text">অন্যান্য ভাতা</small><br>
                    <small>(৪)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Total Provident Fund (if any)<br>
                    <small class="bn-text">মোট প্রভিডেন্ট ফান্ড (যদি থাকে)</small><br>
                    <small>(৫)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Worker's Contribution Amount<br>
                    <small class="bn-text">শ্রমিকের প্রদেয় টাকা</small><br>
                    <small>(৬)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Owner's Contribution Amount<br>
                    <small class="bn-text">মালিকের প্রদেয় টাকা</small><br>
                    <small>(৭)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Signature of Owner/ Authorized Person<br>
                    <small class="bn-text">মালিক/প্রাধিকারপ্রান্ত ব্যক্তির স্বাক্ষর</small><br>
                    <small>(৮)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Worker's Signature<br>
                    <small class="bn-text">শ্রমিকের স্বাক্ষর</small><br>
                    <small>(৯)</small>
                  </th>
                  <th rowspan="2" style="vertical-align: middle">
                    Worker's Thumb Impression<br>
                    <small class="bn-text">শ্রমিকের টিপসই</small><br>
                    <small>(১০)</small>
                  </th>
                </tr>
                <tr>
                  <th>Basic Wage<br><small class="bn-text">মূল মজুরি</small></th>
                  <th>House Rent<br><small class="bn-text">বাড়ি ভাড়া</small></th>
                  <th>Medical<br><small class="bn-text">চিকিৎসা</small></th>
                  <th>Bonus<br><small class="bn-text">বোনাস</small></th>
                  <th>Other Benefits<br><small class="bn-text">অন্যান্য সুবিধা</small></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="items.length == 0 && !loading">
                  <td colspan="15" class="text-center py-5 text-muted">No records found.<br><span class="bn-text">কোন তথ্য পাওয়া যায়নি</span></td>
                </tr>
                <tr v-for="item in items" :key="item.id" class="text-center">
                  <td>
                    {{ formatDate(item.date_of_starting_current_position) }}
                    <br v-if="item.id == activeRecordId" />
                    <span v-if="item.id == activeRecordId" style="color: #28a745; font-size: 11px">&#10004; (Active)</span>
                  </td>
                  <td>{{ getJsonValue(item.job_title_card_number, "en") }}</td>
                  <td>{{ getMwrValue(item.monthly_wage_rate, "basic_wage") }}</td>
                  <td>{{ getMwrValue(item.monthly_wage_rate, "house_rent_allowance") }}</td>
                  <td>{{ getMwrValue(item.monthly_wage_rate, "medical_allowance") }}</td>
                  <td>{{ getMwrValue(item.monthly_wage_rate, "bonus") }}</td>
                  <td>{{ getMwrValue(item.monthly_wage_rate, "other_benefits") }}</td>
                  <td>{{ sumAllowances(getJsonValue(item.other_allowances, "en")) }}</td>
                  <td>{{ getJsonValue(item.total_payable_fund, "en") }}</td>
                  <td>{{ getJsonValue(item.worker_amount_received, "en") }}</td>
                  <td>{{ getJsonValue(item.owner_amount_received, "en") }}</td>
                  <td>
                    <b-link v-if="item.owner_signature" @click="downloadWithName(item.owner_signature, 'Owner_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                  </td>
                  <td>
                    <b-link v-if="item.worker_signature" @click="downloadWithName(item.worker_signature, 'Worker_Signature')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                  </td>
                  <td>
                    <b-link v-if="item.worker_thumb_impression" @click="downloadWithName(item.worker_thumb_impression, 'Thumb_Impression')">
                      <b-icon icon="download" scale="1.2"></b-icon> Download
                    </b-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
export default {
  data() {
    return {
      apiPrefix: "/front/service-book",
      items: [],
      loading: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post(this.$api_url + this.apiPrefix + "/wages-records/fetch", {})
        .then((response) => {
          this.items = response.data || [];
          this.items.forEach((item) => {
             if (item.owner_signature) this.fetchAsBlob(item.owner_signature).then(b => this.$set(item, "_ownerBlob", b));
             if (item.worker_signature) this.fetchAsBlob(item.worker_signature).then(b => this.$set(item, "_workerBlob", b));
             if (item.worker_thumb_impression) this.fetchAsBlob(item.worker_thumb_impression).then(b => this.$set(item, "_thumbBlob", b));
          });
        }).finally(() => { this.loading = false; });
    },
    fetchAsBlob(url) {
      if (!url) return Promise.resolve(null);
      if (url.startsWith('data:')) return Promise.resolve(url);
      return fetch(url, { credentials: "same-origin" }).then(r => r.blob()).then(blob => URL.createObjectURL(blob)).catch(() => url);
    },
    downloadPdf(lang = "both") {
      this.loading = true;
      axios.post(this.$api_url + this.apiPrefix + "/download-wages-records-pdf", { lang: lang }, { responseType: "blob" })
        .then(res => { this.global_download_file_content(res); }).finally(() => { this.loading = false; });
    },
    downloadWithName(path, name) {
      if (!path) return;
      if (path.startsWith('data:image/')) {
        try {
          const parts = path.split(';base64,');
          const contentType = parts[0].split(':')[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) uInt8Array[i] = raw.charCodeAt(i);
          const blob = new Blob([uInt8Array], { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = name + '.' + contentType.split('/')[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
          return;
        } catch (e) {
          console.error("Base64 download failed, falling back to direct URL", e);
        }
      }
      const url = path.startsWith("http") || path.startsWith("data:") ? path : "/" + path;
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getJsonValue(field, lang) {
      if (!field) return "";
      try { const parsed = typeof field === "string" ? JSON.parse(field) : field; return parsed[lang] || ""; } catch (e) { return field; }
    },
    getMwrValue(field, key) {
      if (!field) return "";
      let parsed = field;
      if (typeof field === "string") {
        try {
          parsed = JSON.parse(field);
        } catch (e) {
          return key === "basic_wage" ? field : "";
        }
      }

      if (typeof parsed === "object" && parsed !== null) {
        if ("en" in parsed || "bn" in parsed) {
          return key === "basic_wage" ? (parsed.en || parsed.bn || "") : "";
        }
        const val = parsed[key];
        return val !== undefined && val !== null ? String(val) : "";
      }
      return "";
    },
    sumAllowances(str) {
      if (!str || str == "" || str == "-") return 0;
      if (str.indexOf(":") === -1) return parseFloat(str) || 0;
      let total = 0;
      str.split(",").forEach(p => { let pair = p.split(":"); if (pair.length == 2) total += parseFloat(pair[1].trim()) || 0; });
      return total;
    },
    formatDate(date) { return date ? date.substring(0, 10) : ""; }
  },
  computed:{
    activeRecordId() {
      if (!this.items || this.items.length == 0) return null;
      // The items are already sorted by date DESC by the backend
      var latest = this.items[0];

      // Updated by Jarir 2026-04-28 — Check internal status flag from auto-fetch
      var mwr = latest.monthly_wage_rate;
      if (typeof mwr === "string") {
        try { mwr = JSON.parse(mwr); } catch (e) { mwr = {}; }
      }
      if (mwr && mwr.is_active === 0) return null;

      return latest.id;
    },
  }
};
</script>

<style scoped>
.bn-text { font-family: "notosansbengali", sans-serif; }
.bg-light-blue { background-color: rgb(234, 246, 255) !important; }
.bg-light-cyan { background-color: #e3f2fd; }
.custom-table th { font-size: 0.82rem; vertical-align: middle; }
.custom-table td { font-size: 0.9rem; vertical-align: middle; }
.sig-thumb { max-height: 40px; max-width: 100px; }
</style>
